module.exports = __webpack_public_path__ + "img/20191101110805微信截图_20191101110901.09c33ca8.png";